import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import global_axios from '../../funciones_globales/interaccionapi';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import { cargarCatalogosGenericoAsyncInvertido } from '../../funciones_globales/catalogos';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import moment from 'moment';
import { formatearFechaMoment_a_StringFormatoReporte, formatearFechaMoment_a_String } from '../../funciones_globales/format';

class FormImport16  extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            fechaCorte: null,
            importacion_sel: null,
            detalleImportacion: [],
            colsDefDetImportacion: [
                {   header: "Importacion",
                    field: "Importacion",
                    width: 90,
                    type: "string"
                },
                {   header: "Nombre Proveedor",
                    field: "NombreProveedor",
                    width: 300,
                    type: "string"
                },     
                {   header: "Compra",
                    field: "Compra",
                    width: 140,
                    type: "string"
                },                     
                {   header: "Fecha Compra",
                    field: "FechaCompra",
                    width: 130,
                    type: "string"                               
                },
                {   header: "Fecha Liberacion",
                    field: "FechaLiberacion",
                    width: 130,
                    type: "string"                               
                },
                {   header: "Linea",
                    field: "Linea",
                    width: 130,
                    type: "string"                               
                }
            ]

        };
        //OP OVERCONTROLLS
        this.changeComponents = this.changeComponents.bind(this);
        this.limpiar = this.limpiar.bind(this);
        this.cambiarValoresInput = this.cambiarValoresInput.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.onGridDetImportacionReady = this.onGridDetImportacionReady.bind(this);
        this.ReporteVentaImportacion = this.ReporteVentaImportacion.bind(this);
        this.gridDetImportacionOptions = {
            context: {
                componentParent: this
            }, 
            enableColResize: true,
            enableFilter: true,

        };
    }


        onGridDetImportacionReady(params){
        this.gridDetProformaApi = params.api;
        this.gridDetProformaColumnApi = params.columnApi;
    }   
    
    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
          [name]: value
        });
    }


    changeComponents(event){
        const target = event.target;       
        const name = target.name; 
        const value = target.type === 'checkbox' ? target.checked : target.value; 
        this.setState({[name]: value});
    }

    
    getImportacion(){
 
                let config_request = {
                    method: 'GET',
                    url: '/importaciones/ImportacionVentas'
                }
                this.props.cambiar_VisualizacionLoading(true);
                global_axios(config_request)
                .then((response)=>{
                    this.props.cambiar_VisualizacionLoading(false);
                    let data = response.data;
                    let array = this.formatGridCuentas(data);
                    
                    if(data.length > 0){
                      this.setState({detalleImportacion: array});
                    }else{
                        this.setState({detalleImportacion: array});
                    }
                })
                .catch((error)=>{
                    this.props.cambiar_VisualizacionLoading(false);
                    alert("Ha ocurrido un error: " + error);
                })
            
        }
    
        formatGridCuentas(array){
            let resultArray = [];
            if(array.length > 0){
                array.forEach((CTAS)=>{
                    let item = {};
    
                    item.Compra = CTAS.Compra;
                    item.NombreProveedor = CTAS.NombreProveedor;
                    item.Importacion = CTAS.Importacion;
                    item.FechaCompra = CTAS.FechaCompra;
                    item.FechaLiberacion = CTAS.FechaLiberacion;
                    item.Linea= CTAS.Linea;
                    resultArray.push(item);
                })
            }
            return resultArray;
        }
    


    getOptions_Importaciones(input, callback){
        if (input.toString().length >= 3 ){
            let cadena_busq = '?cadena_busq=' + input;
            cargarCatalogosGenericoAsyncInvertido('/importaciones', cadena_busq, callback)  
        }
    }

    componentDidMount(){
     let fechaProceso = getFechaProcesoPorModulo('03');
     let fechaHasta = moment(fechaProceso, "DD/MM/YYYY");
     this.setState({importacion_sel: null,fechaCorte: fechaHasta

     }, () => this.getImportacion()
    );

         //let FechaCorte = getFechaProcesoPorModulo('03');
       // this.setState({});


                
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0307');
    }

    

    limpiar(){

        //Asignacion de Fecha
        

        this.setState({
            importacion_sel: null,
            
        })
    }

    ReporteVentaImportacion(){
            var continuar = true;
            var error = "";
            let dataEnvio = {};
            let reporte;
            
            reporte = 173;
            
            dataEnvio.fechaCorte =formatearFechaMoment_a_String(this.state.fechaCorte) 
            
            if(this.state.importacion_sel!==null){
                dataEnvio.importacion =this.state.importacion_sel.value
            }
            else {
                 continuar = false;
                error=error+'Debe seleccionar una importacon valida';
            }

            if(continuar === true){
                
                let urlReporte = `&rpt=${reporte}&param1=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaCorte)}`
                let config_request = {
                    method: 'patch',
                    url: '/ValidaImportacionVenta/'+ dataEnvio.importacion,
                    data: dataEnvio
                }
                    this.props.cambiar_VisualizacionLoading(true);
                    global_axios(config_request)
                    .then((response)=>{
                        let data1 = response.data[0];
                        if (data1.Compra===undefined || data1.Compra==='')
                        {
                            this.props.cambiar_VisualizacionLoading(false);
                            alert('Importacion no apta para el reporte');    
                        }
                        else{
                        let Compra = data1.Compra;
                        //alert(Compra);
                        this.props.cambiar_VisualizacionLoading(false); 
                        visualizarReporteEnPdf(urlReporte);
                        }
    
                    })
                    .catch((error)=>{
                        this.props.cambiar_VisualizacionLoading(false);
                        alert(error.response?error.response.data.msg:error.message);
                    });
                }else{
            alert(error)
            }
           
        }


        ResumenVentaImportacion(){
            var continuar = true;
            var error = "";
            let dataEnvio = {};
            let reporte;
            
            reporte = 174;
            dataEnvio.fechaCorte =formatearFechaMoment_a_String(this.state.fechaCorte)
   

            if(continuar === true){
                
                let urlReporte = `&rpt=${reporte}&param1=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaCorte)}`
                let config_request = {
                    method: 'patch',
                    url: '/ResumenImportacionVenta/',
                    data: dataEnvio
                }
                    this.props.cambiar_VisualizacionLoading(true);
                    global_axios(config_request)
                    .then((response)=>{
                        
                        //alert('Ingerso');
                        this.props.cambiar_VisualizacionLoading(false); 
                        visualizarReporteEnPdf(urlReporte);
                        
    
                    })
                    .catch((error)=>{
                        this.props.cambiar_VisualizacionLoading(false);
                        alert(error.response?error.response.data.msg:error.message);
                    });
                }else{
            alert(error)
            }
           
        }
    

    
    
    cambiarValoresInput(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
          [name]: value
        });
    }

    render(){
        return (
            <ContenedorForm porc_ancho={60}>
            <HeaderForm>
                <TituloForm>Reporte de Venta por Importacion</TituloForm>
            </HeaderForm>
                <CuerpoForm>
                    
                    <Row>
                        <ContainerCol className='col-sm-8 col-sm-offset-4 col-sm-pull-4'> 
                            <Row>
                                <ContainerCol className='col-sm-3' margen_arriba='15' margen_abajo='4'>
                                    <LabelForm>Importación:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-6 col-sm-offset-3 col-sm-pull-3' margen_arriba='15' margen_abajo='4'>
                                <ReactSelectAsync value={this.state.importacion_sel} disabled={this.state.operacion==='M'?true:false} func_loadOptions={this.getOptions_Importaciones} func_onChange={(value)=>{this.setState({importacion_sel: value!==null?value:null})}}/>
                                </ContainerCol>
                            </Row>
                            <Row>
                                <ContainerCol className='col-sm-3' margen_arriba='15' margen_abajo='8'>
                                    <LabelForm>Fecha Corte:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-5' margen_arriba='15' margen_abajo='4'>
                                    <PickerFecha fechaSeleccionada={this.state.fechaCorte} func_onChange={(fechaEscogida)=>{this.setState({fechaCorte: fechaEscogida});}}/>
                                </ContainerCol> 
                            </Row>                           
                            <Row>
                                <ContainerCol className='col-sm-12' margen_arriba='15' margen_abajo='4'>
                                    <LabelForm>Se muestra las ultimas 20 importaciones ordenadas por fecha de liberacion como referencia.</LabelForm>
                                    <LabelForm>La importacion seleccionada debe estar liberada para poder ser procesada en el reporte.</LabelForm>
                                </ContainerCol>
                            </Row>
                                                       
                                                        
                        </ContainerCol>
                    </Row>
                    
                    <Row>
                                <div div className='col-sm-12 col-xs-12'>
                                    <AgGridRender altura='200px' data={this.state.detalleImportacion} columnas={this.state.colsDefDetImportacion}
                                    gridOptions={this.gridDetImportacionOptions} onGridReady={this.onGridDetImportacionReady}/>
                                </div>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-12'>
                            <ContainerCol className='btn-group pull-right' margen_arriba='10'>
                                <button type='button' className='btn btn-info btn-sm'  onClick={()=>{this.ReporteVentaImportacion()}}><i className="fa fa-print fa-lg"/> Imprimir</button>  
                                <button type='button' className='btn btn-success btn-sm'  onClick={()=>{this.ResumenVentaImportacion()}}><i className="fa fa-file-excel-o fa-lg"/> Imprimir Resumen</button>
                                <button type="button" className='btn btn-sm'  onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </ContainerCol>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
    return {puntoFacturacionSel: state.ventas.ptoFacturacionSel, 
            permiso: state.sesion.valoresSesionForm.Permiso,
            usuario: state.sesion.valoresSesionForm.Usuario,
            IdRegAudit: state.sesion.valoresSesionForm.IdRegAudit,}
  });
  
  const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm, cambiar_VisualizacionLoading}, dispatch)
  });
  
  export default connect (mapStateToProps, mapDispatchToProps)(FormImport16);